import { useMergedStyles } from 'hooks/useMergedStyles';
import { FC } from 'react';
import { Styles } from 'types/styles';
import styles from './LoaderBar.module.scss';

type Props = {
  newStyles: Styles;
  progress: number;
  animationDuration: number;
  isFinished: boolean;
};
const LoaderBar: FC<Props> = ({ newStyles, progress, animationDuration, isFinished }) => {
  const mergedStyles = useMergedStyles(styles, newStyles);

  return (
    <div
      className={styles['app-loader-bar-wrapper']}
      style={{
        opacity: isFinished ? 0 : 1,
        transition: `all ${animationDuration}ms linear`,
      }}
    >
      <div
        className={mergedStyles['loader-bar']}
        style={{
          marginLeft: `${(-1 + progress) * 100}%`,
          transition: `all ${animationDuration}ms linear`,
        }}
      />
    </div>
  );
};

export default LoaderBar;
